import React, { FC } from 'react';
import classNames from 'classnames';
import { useApp } from '@box/shared/hooks';
import { Controller } from 'react-hook-form';
import ReactSelect, { SelectInstance } from 'react-select';

import { Label } from '../Label';
import { Message } from '../Message';

import { Option, Props } from './Select.types';

import './select.scss';

export const Select: FC<Props> = React.forwardRef<
  SelectInstance<Option>,
  Props
>(
  (
    {
      name,
      control,
      options,
      placeholder,
      onChange,
      className,
      rules,
      label,
      defaultValue,
      menuPlacement,
      error,
      errorMessage,
      disabled,
    },
    ref
  ) => {
    const {
      userEnv: { isMobile },
    } = useApp();
    return (
      <Controller
        name={name}
        control={control}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field }) => {
          return (
            <div className={className}>
              {label && (
                <Label label={label} className='deposit-select__label' />
              )}
              <ReactSelect
                ref={ref}
                className={classNames('deposit-select', {
                  'deposit-select_error': !!error,
                  'deposit-select_mobile': isMobile,
                })}
                classNamePrefix='deposit-select'
                placeholder={placeholder}
                onChange={(v) => onChange(v, field)}
                options={options}
                isSearchable={false}
                menuPlacement={menuPlacement}
                value={
                  options.find((item) => item.value === field.value) || null
                }
                isDisabled={disabled}
              />
              {errorMessage && (
                <Message
                  message={errorMessage}
                  className='deposit-select__error'
                />
              )}
            </div>
          );
        }}
      />
    );
  }
);
